import React from "react";
import Term, { TermData } from "../Term";
import { newsArchiveURIs } from "./variables";

export const categoryAll = -1;

const defalutCategories: { [name: string]: TermData } = {
  all: {
    id: categoryAll,
    term_meta: {
      color: "#E39696",
      icon: '<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8976 1.35229C23.5323 1.98706 23.5323 3.01792 22.8976 3.65269L9.89756 16.6527C9.26279 17.2875 8.23193 17.2875 7.59717 16.6527L1.09717 10.1527C0.462402 9.51792 0.462402 8.48706 1.09717 7.85229C1.73193 7.21753 2.76279 7.21753 3.39756 7.85229L8.7499 13.1996L20.6022 1.35229C21.237 0.717529 22.2679 0.717529 22.9026 1.35229H22.8976Z" fill="white"/></svg>',
      text: "ALL",
    },
    slug: "",
    url: newsArchiveURIs.home,
  },
};

const Categories: React.FC<{
  categories: TermData[];
}> = ({ categories }) => {
  return (
    <>
      <div className="genre-term">
        <div className="genre-term__title">ジャンルから探す</div>
        <div className="genre-term__tags">
          <>
            {[defalutCategories["all"], ...categories].map((category) => (
              <Term
                key={category.id}
                term={category}
                classNamePrefix="genre-term"
              />
            ))}
          </>
        </div>
      </div>
    </>
  );
};

export default Categories;
